import Spinner from "@legacy/core/components/Spinner";
import { FileUpload } from "@molecules";
import { Component } from "react";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import BasicDisplayField from "../../core/fields/BasicDisplayField";
import { JobOriginTypes } from "../../core/utils/enums";


class JobAttachmentForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            triggerCommit: false,
            triggerDiscard: false,
            pendingAction: null,
        }
    }

    handleSaveAction = (action) => {
        const { requestAction } = this.props

        if (window.FILE_UPLOADS_ENABLED) {
            this.setState({ triggerCommit: true, pendingAction: action })
        } else {
            requestAction(action)
        }
    }

    handleCancelAction = () => {
        const { switchToPrimaryForm } = this.props

        if (window.FILE_UPLOADS_ENABLED) {
            this.setState({ triggerDiscard: true })
        } else {
            switchToPrimaryForm()
        }
    }

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    renderButtons = () => {
        const { job, updateAttachmentsData, requestAction, switchToPrimaryForm, submitting, errors, onFormDataChange, returnScroll, updateAttachments, isUploading } = this.props

        if (errors.unexpectedError) {
            return (
                <div className="data-panel__action-feedback">
                    <span className="text-invalid"><strong>An unexpected error occurred.</strong></span>
                </div>
            )
        }
        else {
            if (submitting) {
                return <Spinner centered={true} />
            }
            else {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="primary" text="Save" handler={event => this.handleSaveAction("JOB_UPLOAD_ATTACHMENTS")} disabled={isUploading} />
                            <UniversalButton type="secondary" text="Cancel" handler={event => this.handleCancelAction()} disabled={isUploading} />
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
        }
    }

    render() {
        const { job, updateAttachmentsData, requestAction, switchToPrimaryForm, submitting, errors, onFormDataChange, returnScroll, setIsUploading } = this.props

        return (
            <div className="data-panel-container data-panel-container--with-margin">
                <div className="data-panel" aria-label="Job Pause">
                    <div className="data-panel__form" aria-label="Job Pause Form">
                        <BasicDisplayField
                            fieldName="id"
                            fieldLabel="Roopairs Job ID"
                            fieldValue={job.custom_id ? job.custom_id : job.id}
                        ></BasicDisplayField>
                        {
                            job.origin_type !== JobOriginTypes.roopairs && (
                                <BasicDisplayField
                                    fieldName="origin_id"
                                    fieldLabel={`${job.origin_type_label} ID`}
                                    fieldValue={job.origin_id}
                                ></BasicDisplayField>
                            )
                        }
                        <BasicDisplayField
                            fieldName="service_name"
                            fieldLabel="Service Type"
                            fieldValue={job.service_name}
                        ></BasicDisplayField>
                        <BasicDisplayField
                            fieldName="is_job_walk"
                            fieldLabel="Job Type"
                            fieldValue={job.is_recall ? "Recall" : job.is_job_walk ? "Job Walk" : "Service"}
                        ></BasicDisplayField>

                        {
                            <div className="data-panel__form__field">
                                <FileUpload
                                    mode="attached"
                                    objectType="job"
                                    objectId={job.id}
                                    existingAttachments={job.attachments}
                                    autoUpload={true}
                                    autoCommit={false}
                                    triggerCommit={this.state.triggerCommit}
                                    triggerDiscard={this.state.triggerDiscard}
                                    label={{ label: "Attachments", isOptional: true }}
                                    onCommitComplete={() => {
                                        const action = this.state.pendingAction
                                        this.setState({ triggerCommit: false, pendingAction: null })
                                        if (action) {
                                            requestAction(action)
                                        }
                                    }}
                                    onDiscardComplete={() => {
                                        this.setState({ triggerDiscard: false, pendingAction: null })
                                        switchToPrimaryForm()
                                    }}
                                    onFileUploadError={(file, error) => {
                                        console.error("Job attachment upload error:", file.name, error)
                                    }}
                                    onUploadingChange={(uploading) => {
                                        if (setIsUploading) {
                                            setIsUploading(uploading)
                                        }
                                    }}
                                />
                            </div>
                        }
                    </div>
                    {this.renderButtons()}
                </div>
            </div>
        )
    }
}

export default JobAttachmentForm;
